import { type TransactionSortBy } from '@ankor-io/common/types/transaction/transaction'

export type { TransactionSortBy }
export type TransactionSortOrder = 'asc' | 'desc'

export type TransactionTableSort = {
  sortBy: TransactionSortBy
  sortOrder: TransactionSortOrder
}

export const DEFAULT_TRANSACTION_TABLE_SORT: TransactionTableSort = {
  sortBy: 'date',
  sortOrder: 'desc',
}

const DEFAULT_SORT_ORDER: Partial<Record<TransactionSortBy, TransactionSortOrder>> = {
  date: 'desc',
  amountCents: 'asc',
  status: 'asc',
  vendor: 'asc',
  charterName: 'asc',
  categoryName: 'asc',
  paymentStatus: 'asc',
}

export function getDefaultSortOrder(sortKey: TransactionSortBy): TransactionSortOrder {
  return DEFAULT_SORT_ORDER[sortKey] ?? 'desc'
}

export function getNextTransactionSort(
  current: TransactionTableSort,
  clicked: TransactionSortBy,
): TransactionTableSort {
  if (current.sortBy === clicked) {
    return {
      sortBy: clicked,
      sortOrder: current.sortOrder === 'desc' ? 'asc' : 'desc',
    }
  }

  return {
    sortBy: clicked,
    sortOrder: getDefaultSortOrder(clicked),
  }
}
